export default "__VITE_ASSET__53a52e13__"